import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'

import { accountsService } from 'src/services/accounts.service'
import { IAccountByIdRespDto } from 'src/types'

export const useUpdateAccount2FARequirement = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(
    async (required: boolean) => {
      if (!accountId) return null

      return accountsService.updateAccount2FARequierd(accountId, required)
    },
    {
      onSuccess(data, required) {
        if (!data) return

        queryClient.setQueryData([QUERY_KEYS.ACCOUNT, accountId], (prev?: IAccountByIdRespDto) => {
          return prev ? { ...prev, two_factor_required: required } : ({} as IAccountByIdRespDto)
        })
      },
    },
  )
}
